export function camelToDashes(str) {
    return str.replace(/([A-Z])/g, '-$1').replace(/^-/, '')
    .toLowerCase();
}

export function dashesToCamel(str) {
    return str.replace(/-([a-z])/g, g => g[1].toUpperCase());
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}




// WEBPACK FOOTER //
// ./src/util.js